import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import TuneIcon from "@mui/icons-material/Tune";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Card, Container, Grid, Typography } from "@mui/material";
import { groupBy, uniqBy } from "lodash";
import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import Table from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect, {
  default as Select,
} from "../../../components/Select/Select";
import SplitButton from "../../../components/SplitButtion";
import { soapApiJson } from "../../../redux/actions/api";
import {
  createClinicService,
  editClinicService,
  getClinicStocks,
  getServiceCategoryByTypeWOLoader,
  getServicesByFilter,
  updateServiceStatusByIds,
} from "../../../redux/reducers/clinicSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import { AppColors } from "../../../util/AppColors";
import { frequncyCheckList } from "../../../util/arrayList";
import {
  devices,
  doneAtList,
  mealTypes,
  modalities,
  regionList,
  routeList,
  sampleTypes,
  ServiceTypes,
  yesNoValueList,
} from "../../../util/dropList";
import { getTotalEstimatedCost, transformData } from "../../../util/function";

const tableHeaders = [
  "checkbox",
  "serviceName",
  "category",
  "serStatus",
  "subCategory",
  "sacCode",
  "sellingPrice",
];

const initVariant = { modOpen: false, consumList: [], presList: [] };

const initialValues = {
  type: "Medical",
  category: null,
  subCategory: null,
  serviceName: "",
  taxApplicability: "No",
  name: "",
  tax: "",
  serviceCharge: "",
  servicePrice: "",
  description: "",
  hsnSacCode: "",
  variants: [{ ...initVariant, i: 0 }],
  sampleType: "Blood",
  doneAt: "In-house",
  modality: null,
  device: "MRI",
  processingTime: "",
  region: [],
};
const initialError = {
  category: false,
  subCategory: false,
  serviceName: false,
  taxApplicability: false,
  serviceCharge: false,
  servicePrice: false,
  description: false,
  hsnSacCode: false,
};

const initialHelp = {
  category: "",
  subCategory: "",
  serviceName: "",
  taxApplicability: "",
  serviceCharge: "",
  servicePrice: "",
  description: "",
  hsnSacCode: "",
};

const requiredFieldList = [
  "category",
  "subCategory",
  "serviceName",
  "taxApplicability",
  "tax",
];

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
};
const plusBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };
const initItem = {
  name: "",
  quantity: "1",
  cost: 0,
  route: null,
  dosage: "",
  delete: false,
};
const initVariants = { consumList: [], presList: [], prescriptions: [] };

const initSearch = { name: "", category: "", subCategory: "", type: null };
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = ["Variant ID", "Variant Name", "SAC Code", "Price Range"];

const Service = () => {
  const dispatch = useDispatch();
  const [internalDescription, setInternalDescription] = useState("");
  const [serviceValues, setServiceValues] = useState(initialValues);
  const [serviceErrors, setServiceErrors] = useState(initialError);
  const [serviceHelps, setServiceHelps] = useState(initialHelp);
  const [serviceId, setServiceId] = useState(null);
  const [modVisible, setModVisible] = useState(false);
  const [tableServices, setTableServices] = useState([]);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [searchValue, setSearchValue] = useState("");
  const [itemErrors, setItemErrors] = useState({
    consumList: [],
    presList: [],
  });
  const [page, setPage] = useState(1);
  const [consumOpen, setConsumOpen] = useState(true);
  const [adminOpen, setAdminOpen] = useState(true);
  const [alternates, setAlternates] = useState([]);
  const [slctedVariant, setSlctedVariant] = useState(null);
  const [variantValues, setVariantValues] = useState(initVariants);
  const [filterValues, setFilterValues] = useState(initFilter);
  const {
    services,
    serviceCategories,
    clinicStocks: stocks,
    servicesList,
  } = useSelector((state) => state?.clinic);
  const rowsPerPage = 10;
  const defaultUrl = `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`;

  useEffect(() => {
    //for calling the init api call to load the data
    // onServiceApiCall(1);

    // Reset filter values to initial state when component mounts
    setFilterValues({ ...initFilter, selectedList: [], values: {} });

    dispatch(getServiceCategoryByTypeWOLoader("Medical"));
    dispatch(getClinicStocks());
  }, []);

  useEffect(() => {
    // const hasSearchValues =
    //   searchValues?.name?.trim() ||
    //   (searchValues?.category && searchValues?.category?.length > 0) ||
    //   (searchValues?.subCategory && searchValues?.subCategory?.length > 0) ||
    //   (searchValues?.type && searchValues?.type?.length > 0);
    // if (hasSearchValues) {
    onServiceApiCall(1);
    // }
  }, [
    searchValues?.name,
    searchValues?.category,
    searchValues?.subCategory,
    searchValues?.type,
  ]);

  // useEffect(() => {
  //   dispatch(getServices(defaultUrl));
  //   setPage(1);
  // }, [searchValue]);

  useEffect(() => {
    getServiceTableData();
  }, [servicesList?.data]);

  // useEffect(() => {
  //   getServiceTableData();
  // }, [services?.data]);

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const reqObj = { page: currentPage, itemSize: rowsPerPage };
    if (reset) return reqObj;
    if (searchValues?.name?.length > 0)
      reqObj.procedureName = searchValues?.name;
    if (searchValues?.category?.length > 0)
      reqObj.category = searchValues?.category;
    if (searchValues?.subCategory?.length > 0)
      reqObj.subCategory = searchValues?.subCategory;
    if (searchValues?.type) reqObj.type = searchValues?.type;

    if (
      filterValues?.selectedList?.includes("Variant ID") &&
      filterValues?.values?.["Variant ID"]?.length > 0
    )
      reqObj.variantNumber = filterValues?.values?.["Variant ID"];
    if (
      filterValues?.selectedList?.includes("Variant Name") &&
      filterValues?.values?.["Variant Name"]?.length > 0
    )
      reqObj.variantName = filterValues?.values?.["Variant Name"];
    if (
      filterValues?.selectedList?.includes("SAC Code") &&
      filterValues?.values?.["SAC Code"]?.length > 0
    )
      reqObj.sacCode = filterValues?.values?.["SAC Code"];
    if (filterValues?.selectedList?.includes("Price Range")) {
      reqObj.minPrice = Number(filterValues?.values?.["Min Price"] ?? 0);
      reqObj.maxPrice = Number(filterValues?.values?.["Max Price"] ?? 0);
    }
    return reqObj;
  };

  const onServiceApiCall = (currentPage = 1, reset = false) => {
    dispatch(getServicesByFilter(getFilterObj(currentPage, reset)));
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = tableServices?.map((ser, i) => {
      if (i === ind) {
        return { ...ser, selected: value };
      }
      return ser;
    });
    setTableServices(reqList);
  };

  const getServiceTableData = () => {
    const reqList = servicesList?.data?.map((ser, i) => {
      //  services?.data
      return {
        ...ser,
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div
            className="cursor blue-color underline font-bold fs14"
            onClick={() => handleEditModal(ser?.serviceId)}
          >
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: ser?.servicePrice,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        hsnSacCode: ser?.hsnSacCode,
        selected: false,
      };
    });
    setTableServices(reqList);
  };

  const getSupplierTable = () => {
    return tableServices?.map((ser, i) => {
      return {
        checkbox: (
          <CustomCheckbox
            checked={ser?.selected}
            onChange={() => handleChangeCheckBox(!ser?.selected, i)}
          />
        ),
        serviceName: (
          <div
            className="cursor"
            onClick={() => handleEditModal(ser?.serviceId)}
          >
            {ser?.serviceName}
          </div>
        ),
        serStatus: (
          <div style={{ width: 80 }}>
            {ser?.active === "Y" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium">
                Active
              </Typography>
            ) : (
              <Typography className="red11 red-back status-card fs12 font-medium">
                Inactive
              </Typography>
            )}
          </div>
        ),
        sellingPrice: ser?.servicePrice,
        description: ser?.description,
        category: ser?.category,
        subCategory: ser?.subCategory,
        sacCode: ser?.hsnSacCode,
        selected: ser?.selected,
      };
    });
  };

  const handleOpen = () => {
    setModVisible(true);
  };

  const handleClose = () => {
    setModVisible(false);
    setServiceValues(initialValues);
    setServiceErrors(initialError);
    setServiceHelps(initialHelp);
    setServiceId(false);
  };

  const validateConsumItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    if (!item?.quantity || Number(item?.quantity) < 1)
      errors.quantity = "Valid quantity is required";
    return errors;
  };

  const validatePresItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    if (!item?.dosage || Number(item?.dosage) < 1)
      errors.dosErr = "Valid Dosage is required";
    if (!item?.route?.value) errors.routeErr = "Route is required";
    return errors;
  };

  const validatePrescripItem = (item) => {
    const errors = {};
    if (!item?.name || item?.name?.length === 0)
      errors.nameErr = "Name is required";
    if (!item?.qty || Number(item?.qty) < 1)
      errors.qtyErr = "Valid Quantity is required";
    return errors;
  };

  const isVariantsNotValid = () => {
    const reqVariants = serviceValues?.variants?.map((vl) => {
      const reqObj = { ...vl };
      if (vl?.variantName?.length === 0 || !vl?.variantName) {
        reqObj.nameErr = "This field is required";
      }
      if (
        vl?.serviceCharge === undefined ||
        vl?.serviceCharge === null ||
        vl?.serviceCharge === "" ||
        Number(vl?.serviceCharge) < 0
      ) {
        reqObj.chargeErr =
          vl?.serviceCharge?.length === 0
            ? "This field is required"
            : "Value must be positive";
      }
      if (
        vl?.servicePrice === undefined ||
        vl?.servicePrice === null ||
        vl?.servicePrice === "" ||
        Number(vl?.servicePrice) < 0
      ) {
        reqObj.serPriceErr =
          vl?.servicePrice?.length > 0
            ? "Value must be positive"
            : "This field is required";
      }
      if (
        serviceValues?.category?.value === "Radiology" &&
        (!vl?.region || vl?.region?.length === 0)
      ) {
        reqObj.regionErr = "This field is required";
      }
      if (checkEstDurationIsMandatory() && !vl?.estimatedDuration) {
        if (
          !vl?.estimatedDuration ||
          vl?.estimatedDuration?.length === 0 ||
          Number(vl?.estimatedDuration) < 0
        ) {
          reqObj.durError =
            vl?.estimatedDuration?.length > 0
              ? "Value must be positive"
              : "This field is required";
        }
      }
      return reqObj;
    });
    setServiceValues({ ...serviceValues, variants: reqVariants });

    return reqVariants?.some(
      (variant) =>
        variant?.nameErr?.length > 0 ||
        variant?.chargeErr?.length > 0 ||
        variant?.serPriceErr?.length > 0 ||
        variant?.durError?.length > 0
    );
  };

  const handleSubmit = async () => {
    dispatch(showLoader());
    let errObj = {};
    let hlpObj = {};
    requiredFieldList?.forEach((fld) => {
      const reqValue =
        typeof serviceValues?.[fld] === "object"
          ? serviceValues?.[fld]?.value
          : serviceValues?.[fld];
      if (
        reqValue?.length === 0 ||
        (typeof reqValue === "number" && reqValue === 0) ||
        reqValue === undefined
      ) {
        errObj = {
          ...errObj,
          [fld]:
            fld === "tax"
              ? serviceValues?.taxApplicability?.toLowerCase() === "no"
                ? false
                : true
              : true,
        };
        hlpObj = {
          ...hlpObj,
          [fld]:
            serviceValues?.taxApplicability?.toLowerCase() === "no"
              ? ""
              : "This field is required",
        };
      } else {
        errObj = { ...errObj, [fld]: false };
        hlpObj = { ...hlpObj, [fld]: "" };
      }
      if (fld === "serviceCharge" || fld === "servicePrice") {
        if (
          Number(serviceValues?.[fld]) >= 0 ||
          serviceValues?.[fld]?.length === 0
        ) {
          errObj = {
            ...errObj,
            [fld]:
              serviceValues?.[fld] > 0
                ? Number(serviceValues?.[fld]) >= 0
                  ? false
                  : true
                : true,
          };
          hlpObj = {
            ...hlpObj,
            [fld]:
              serviceValues?.[fld]?.length > 0
                ? Number(serviceValues?.[fld]) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required",
          };
        }
      }
      if (fld === "subCategory") {
        if (serviceValues?.category?.value === "Radiology") {
          errObj = { ...errObj, subCategory: false };
          hlpObj = { ...hlpObj, subCategory: "" };
        }
      }
    });
    setServiceErrors({ ...serviceErrors, ...errObj });
    setServiceHelps({ ...serviceHelps, ...hlpObj });
    if (
      Object.keys(errObj)?.some((val) => errObj?.[val] === true) ||
      isVariantsNotValid()
    ) {
      dispatch(hideLoader());
      return;
    }
    const serviceVariants = serviceValues?.variants?.map((vl) => {
      const varObj = {
        variantName: vl?.variantName,
        serviceCharge: Number(vl?.serviceCharge),
        servicePrice: Number(vl?.servicePrice),
        variantNumber: vl?.variantNumber,
        estimatedDuration:
          vl?.estimatedDuration?.length > 0
            ? Number(vl?.estimatedDuration)
            : "",
        region: vl?.region ?? [],
        device: vl?.device ?? null,
        doneAt: vl?.doneAt ?? null,
      };
      if (vl?.variantId) varObj.variantId = vl?.variantId;
      varObj.delete = serviceId ? vl?.delete : false;
      let serviceDetailRequests = [];
      let servicePrescription = [];
      if (vl?.consumList?.length > 0) {
        vl?.consumList?.forEach((li) => {
          const reqObj = {
            name: li?.name,
            quantity: Number(li?.quantity),
            stockId: li?.stockId ?? null,
            estimatedCost: Number(li?.cost),
          };
          if (li?.stockId) {
            reqObj.batchId = getBatchList(li?.stockId)?.[0]?.batchId;
          }
          if (li?.detailId) reqObj.detailId = li?.detailId;
          if (serviceId) {
            reqObj.delete = li?.delete;
          } else {
            reqObj.delete = false;
          }
          if (!li?.alternates || li?.alternates?.length === 0) {
            reqObj.alter = "N";
            serviceDetailRequests.push(reqObj);
          } else {
            reqObj.alter = "Y";
            serviceDetailRequests.push(reqObj);
            li?.alternates?.forEach((al) => {
              const altObj = {
                name: al?.name,
                quantity: Number(al?.quantity),
                stockId: al?.stockId ?? null,
                estimatedCost: Number(al?.cost),
                alter: "N",
                alterName: li?.name,
              };
              if (al?.stockId) {
                altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
              }
              if (al?.detailId) altObj.detailId = al?.detailId;
              if (serviceId) {
                altObj.delete = al?.delete;
              } else {
                altObj.delete = false;
              }
              serviceDetailRequests.push(altObj);
            });
          }
        });
      }
      if (vl?.presList?.length > 0) {
        vl?.presList?.forEach((pre) => {
          const reqObj = {
            administered: "Administered",
            type: pre?.type ?? null,
            name: pre?.name ?? null,
            dosage: pre?.dosage,
            quantity: 1,
            vaccineType: pre?.route?.value,
            duration: "1",
            stockId: pre?.stockId ?? null,
            batchId: pre?.batchId ?? null,
            estimatedCost: Number(pre?.cost),
          };
          if (pre?.stockId) {
            reqObj.batchId = getBatchList(pre?.stockId)?.[0]?.batchId;
          }
          if (pre?.prescriptionId) reqObj.prescriptionId = pre?.prescriptionId;
          if (serviceId) {
            reqObj.delete = pre?.delete;
          } else {
            reqObj.delete = false;
          }
          if (!pre?.alternates || pre?.alternates?.length === 0) {
            reqObj.alter = "N";
            servicePrescription.push(reqObj);
          } else {
            reqObj.alter = "Y";
            servicePrescription.push(reqObj);
            pre?.alternates?.forEach((al) => {
              const altObj = {
                administered: "Administered",
                type: al?.type ?? null,
                name: al?.name ?? null,
                dosage: al?.dosage,
                quantity: 1,
                vaccineType: al?.route?.value,
                duration: "1",
                stockId: al?.stockId ?? null,
                batchId: al?.batchId ?? null,
                estimatedCost: Number(al?.cost),
                alter: "N",
                alterName: pre?.name,
              };
              if (al?.stockId) {
                altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
              }
              if (al?.prescriptionId)
                altObj.prescriptionId = al?.prescriptionId;
              if (serviceId) {
                altObj.delete = al?.delete;
              } else {
                altObj.delete = false;
              }
              servicePrescription.push(altObj);
            });
          }
        });
      }
      if (vl?.prescriptions?.length > 0) {
        vl?.prescriptions?.forEach((pre) => {
          const reqObj = {
            administered: "Prescribed",
            type: pre?.type ?? null,
            name: pre?.name ?? null,
            dosage: pre?.dosage,
            quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
            duration: pre?.duration ?? "1",
            stockId: pre?.stockId ?? null,
            batchId: pre?.batchId ?? null,
            estimatedCost: 0,
            meal: pre?.meal ?? "",
            morning:
              (pre?.frequency?.includes("morning") &&
                !pre?.frequency?.includes("Custom")) ??
              false,
            afternoon:
              (pre?.frequency?.includes("afternoon") &&
                !pre?.frequency?.includes("Custom")) ??
              false,
            night:
              (pre?.frequency?.includes("night") &&
                !pre?.frequency?.includes("Custom")) ??
              false,
            remark: pre?.remark ?? "",
          };
          if (typeof pre?.frequency === "string") {
            reqObj.frequencyDuration = pre?.frequency;
          }
          if (pre?.stockId) {
            reqObj.batchId = getBatchList(pre?.stockId)?.[0]?.batchId;
          }
          if (pre?.prescriptionId) reqObj.prescriptionId = pre?.prescriptionId;
          if (serviceId) {
            reqObj.delete = pre?.delete;
          } else {
            reqObj.delete = false;
          }
          servicePrescription.push(reqObj);
          // if (!pre?.alternates || pre?.alternates?.length === 0) {
          //   reqObj.alter = "N";
          //   servicePrescription.push(reqObj);
          // } else {
          //   reqObj.alter = "Y";
          //   servicePrescription.push(reqObj);
          //   pre?.alternates?.forEach((al) => {
          //     const altObj = {
          //       administered: "Administered",
          //       type: al?.type ?? null,
          //       name: al?.name ?? null,
          //       dosage: al?.dosage,
          //       quantity: 1,
          //       vaccineType: al?.route?.value,
          //       duration: "1",
          //       stockId: al?.stockId ?? null,
          //       batchId: al?.batchId ?? null,
          //       estimatedCost: Number(al?.cost),
          //       alter: "N",
          //       alterName: pre?.name,
          //     };
          //     if (al?.stockId) {
          //       altObj.batchId = getBatchList(al?.stockId)?.[0]?.batchId;
          //     }
          //     if (al?.prescriptionId)
          //       altObj.prescriptionId = al?.prescriptionId;
          //     if (serviceId) {
          //       altObj.delete = al?.delete;
          //     } else {
          //       altObj.delete = false;
          //     }
          //     servicePrescription.push(altObj);
          //   });
          // }
        });
      }
      varObj.serviceDetailRequests = serviceDetailRequests;
      varObj.servicePrescription = servicePrescription;
      return varObj;
    });

    soapApiJson
      .post("/service", {
        service_name: serviceValues?.serviceName,
        service_details: {
          list: JSON.stringify(transformData(serviceValues?.variants)),
        },
      })
      .then((res) => {
        let serviceDescription = "",
          serviceVector = [];
        if (res?.status === 200) {
          if (res?.data) {
            serviceDescription = res?.data?.ServiceDescription;
            serviceVector = res?.data?.ServiceVector;
          }
          dispatch(showLoader());
          const serviceData = {
            active: serviceValues?.active ? "N" : "Y",
            type: serviceValues?.type,
            category: serviceValues?.category?.value,
            subCategory:
              serviceValues?.category?.value === "Radiology"
                ? null
                : serviceValues?.subCategory?.value,
            serviceName: serviceValues?.serviceName,
            taxApplicability: serviceValues?.taxApplicability,
            tax:
              serviceValues?.taxApplicability?.toLowerCase() === "yes"
                ? Number(serviceValues?.tax ?? 0)
                : 0,
            servicePrice:
              Number(serviceVariants?.[0]?.servicePrice ?? 0) +
              Number(
                getTotalEstimatedCost([
                  ...(serviceVariants?.[0]?.consumList ?? []),
                  ...(serviceVariants?.[0]?.presList ?? []),
                ]) ?? 0
              ),
            serviceCharge: serviceVariants?.[0]?.serviceCharge,
            description: serviceValues?.description,
            internalDescription: serviceDescription,
            serviceVector: serviceVector,
            hsnSacCode: serviceValues?.hsnSacCode,
            serviceVariants,
          };
          if (
            serviceValues?.category?.value === "Lab" ||
            serviceValues?.category?.value === "Radiology"
          ) {
            serviceData.doneAt = serviceValues?.doneAt;
            serviceData.processingTime = serviceValues?.processingTime;
            if (serviceValues?.category?.value === "Lab") {
              serviceData.sampleType = serviceValues?.sampleType;
            }
          }
          try {
            if (serviceId) {
              dispatch(
                editClinicService({ id: serviceId, data: serviceData })
              ).then((res) => {
                if (res?.payload) {
                  dispatch(hideLoader());
                  onServiceApiCall(1);
                  // dispatch(
                  //   getServices(
                  //     `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`
                  //   )
                  // );
                  // setPage(1);
                  setModVisible(!modVisible);
                  setItemErrors({
                    consumList: [],
                    presList: [],
                  });
                  setServiceId(null);
                  setServiceValues(initialValues);
                }
                dispatch(hideLoader());
              });
            } else {
              dispatch(createClinicService(serviceData)).then((res) => {
                if (res?.payload) {
                  dispatch(hideLoader());
                  onServiceApiCall(1);
                  // dispatch(
                  //   getServices(
                  //     `?page=1&itemSize=${rowsPerPage}&search=${searchValue}`
                  //   )
                  // );
                  // setPage(1);
                  setModVisible(!modVisible);
                  setServiceId(null);
                  setItemErrors({
                    consumList: [],
                    presList: [],
                  });
                  setServiceValues(initialValues);
                }
                dispatch(hideLoader());
              });
            }
          } catch (error) {
            dispatch(hideLoader());
            console.error("Error:", error);
          }
        } else {
          dispatch(hideLoader());
        }
      });
  };

  const handleChangePage = (e, selectedPage) => {
    onServiceApiCall(selectedPage);
    // setPage(selectedPage);
    setTableServices([]);
    // dispatch(
    //   getServices(
    //     `?page=${selectedPage}&itemSize=${rowsPerPage}&search=${searchValue}`
    //   )
    // );
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setPage(1);
    setTableServices([]);
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    if (name === "type") {
      dispatch(getServiceCategoryByTypeWOLoader(value));
    }
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const handleChange = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...serviceValues, [name]: value };
    let errObj = { ...serviceErrors, [name]: false };
    let hlpObj = { ...serviceHelps, [name]: "" };
    if (reqValue?.length > 0) {
      if (name === "type") {
        dispatch(getServiceCategoryByTypeWOLoader(value));
        reqObj.taxApplicability = value === "Medical" ? "No" : "Yes";
        reqObj.category = null;
        reqObj.subCategory = null;
      }
      if (name === "category") {
        reqObj.subCategory = null;
      }
      if (name === "serviceCharge" || name === "servicePrice") {
        errObj = {
          ...errObj,
          [name]:
            reqValue?.length > 0
              ? Number(reqValue) >= 0
                ? false
                : true
              : true,
        };
        hlpObj = {
          ...hlpObj,
          [name]:
            reqValue?.length > 0
              ? Number(reqValue) >= 0
                ? ""
                : "Value must be positive"
              : "This field is required",
        };
      }
    } else {
      errObj = {
        ...errObj,
        [name]: requiredFieldList?.includes(name) ? true : false,
      };
      hlpObj = {
        ...hlpObj,
        [name]: requiredFieldList?.includes(name)
          ? "This field is required"
          : "",
      };
    }
    if (name === "modality") {
      reqObj.region = [];
    }
    if (name === "region") {
      errObj = {
        ...errObj,
        [name]: value?.length > 0 ? false : true,
      };
      hlpObj = {
        ...hlpObj,
        [name]: value?.length > 0 ? "" : "This field is required",
      };
    }
    setServiceHelps(hlpObj);
    setServiceErrors(errObj);
    setServiceValues(reqObj);
  };

  const handleEditModal = (id) => {
    const slctedSer = servicesList?.data?.find(
      (product) => product?.serviceId === id
    );
    if (slctedSer) {
      const variants = (slctedSer?.serviceVariants ?? slctedSer?.variants)?.map(
        (vl, i) => {
          const varObj = {
            ...vl,
            delete: false,
            i,
            estimatedDuration: vl?.estimatedDuration ?? "",
          };
          let reqConsums = [],
            presLists = [],
            prescriptions = [];
          if (vl?.serviceDetails?.length > 0) {
            vl?.serviceDetails
              ?.filter(
                (li) =>
                  (li?.alterType === "N" && !li?.alterName) ||
                  (li?.alterType === "Y" && !li?.alterName)
              )
              ?.forEach((li) => {
                reqConsums.push({
                  ...li,
                  cost: li?.estimatedCost,
                  delete: false,
                });
              });
            const alters = vl?.serviceDetails?.filter(
              (li) => li?.alterType === "N" && li?.alterName
            );
            const groupAlters = groupBy(alters, "alterName");
            reqConsums = reqConsums?.map((li) => {
              if (groupAlters?.[li?.name]?.length > 0) {
                const reqAlters = groupAlters?.[li?.name]?.map((al, i) => ({
                  ...al,
                  i,
                  isDefault: i === 0,
                  cost: al?.estimatedCost,
                  delete: false,
                }));
                return { ...li, alternates: reqAlters };
              }
              return li;
            });
          }
          varObj.consumList = reqConsums?.map((li, i) => ({ ...li, i }));
          if (vl?.servicePrescreiptions?.length > 0) {
            vl?.servicePrescreiptions
              ?.filter(
                (li) =>
                  (li?.administered === "Administered" &&
                    li?.alterType === "N" &&
                    !li?.alterName) ||
                  (li?.alterType === "Y" && !li?.alterName)
              )
              ?.forEach((li, i) => {
                const batch = getBatchList(li?.stockId)?.[0];
                const reqObj = {
                  prescriptionId: li?.prescriptionId,
                  name: li?.name,
                  stockId: li?.stockId,
                  batchId: li?.batchId,
                  quantity: li?.quantity,
                  administered: "Administered",
                  route: routeList?.find((rl) => rl?.value === li?.vaccineType),
                  dosage: li?.dosage,
                  type: li?.type,
                  duration: li?.duration,
                  batchNumber: batch,
                  cost: li?.estimatedCost,
                  delete: false,
                };
                presLists.push(reqObj);
              });
            const alters = vl?.servicePrescreiptions?.filter(
              (li) => li?.alterType === "N" && li?.alterName
            );
            const groupAlters = groupBy(alters, "alterName");
            presLists = presLists?.map((li) => {
              if (groupAlters?.[li?.name]?.length > 0) {
                const reqAlters = groupAlters?.[li?.name]?.map((al, i) => {
                  const batch = getBatchList(li?.stockId)?.[0];
                  const reqObj = {
                    i,
                    isDefault: i === 0,
                    prescriptionId: al?.prescriptionId,
                    name: al?.name,
                    stockId: al?.stockId,
                    batchId: al?.batchId,
                    quantity: al?.quantity,
                    administered: "Administered",
                    route: routeList?.find(
                      (rl) => rl?.value === al?.vaccineType
                    ),
                    dosage: al?.dosage,
                    type: al?.type,
                    duration: al?.duration,
                    batchNumber: batch,
                    cost: al?.estimatedCost,
                    delete: false,
                  };
                  return reqObj;
                });
                return { ...li, alternates: reqAlters };
              }
              return li;
            });

            vl?.servicePrescreiptions
              ?.filter((li) => li?.administered === "Prescribed")
              ?.forEach((li, i) => {
                const batch = getBatchList(li?.stockId)?.[0];
                const reqObj = {
                  prescriptionId: li?.prescriptionId,
                  name: li?.name,
                  stockId: li?.stockId,
                  batchId: li?.batchId,
                  quantity: li?.quantity,
                  qty: li?.quantity,
                  administered: "Prescribed",
                  // route: routeList?.find((rl) => rl?.value === li?.vaccineType),
                  dosage: li?.dosage,
                  type: li?.type,
                  duration: li?.duration,
                  batchNumber: batch,
                  cost: li?.estimatedCost,
                  delete: false,
                  frequency:
                    li?.morning || li?.afternoon || li?.night
                      ? [
                          li?.morning && "morning",
                          li?.afternoon && "afternoon",
                          li?.night && "night",
                        ]?.filter(Boolean)
                      : li?.frequencyDuration?.length > 0
                      ? li?.frequencyDuration
                      : null,
                  customFrequency:
                    !li?.morning &&
                    !li?.afternoon &&
                    !li?.night &&
                    li?.frequencyDuration?.length > 0,
                  meal: li?.meal,
                  remark: li?.remark ?? "",
                };
                prescriptions.push(reqObj);
              });
            // const alters = vl?.servicePrescreiptions?.filter(
            //   (li) => li?.alterType === "N" && li?.alterName
            // );
            // const groupAlters = groupBy(alters, "alterName");
            // presLists = presLists?.map((li) => {
            //   if (groupAlters?.[li?.name]?.length > 0) {
            //     const reqAlters = groupAlters?.[li?.name]?.map((al, i) => {
            //       const batch = getBatchList(li?.stockId)?.[0];
            //       const reqObj = {
            //         i,
            //         isDefault: i === 0,
            //         prescriptionId: al?.prescriptionId,
            //         name: al?.name,
            //         stockId: al?.stockId,
            //         batchId: al?.batchId,
            //         quantity: al?.quantity,
            //         administered: "Administered",
            //         route: routeList?.find((rl) => rl?.value === al?.vaccineType),
            //         dosage: al?.dosage,
            //         type: al?.type,
            //         duration: al?.duration,
            //         batchNumber: batch,
            //         cost: al?.estimatedCost,
            //         delete: false,
            //       };
            //       return reqObj;
            //     });
            //     return { ...li, alternates: reqAlters };
            //   }
            //   return li;
            // });
          }
          varObj.presList = presLists?.map((li, i) => ({ ...li, i }));
          varObj.prescriptions =
            prescriptions?.length > 0
              ? prescriptions?.map((li, i) => ({ ...li, i }))
              : [];
          return varObj;
        }
      );
      dispatch(getServiceCategoryByTypeWOLoader(slctedSer?.type));
      const reqObj = {
        ...serviceValues,
        active: slctedSer?.active === "N",
        category: slctedSer?.category
          ? { name: slctedSer?.category, value: slctedSer?.category }
          : null,
        subCategory: slctedSer?.subCategory
          ? { name: slctedSer?.subCategory, value: slctedSer?.subCategory }
          : null,
        serviceName: slctedSer?.serviceName,
        taxApplicability: slctedSer?.taxApplicability,
        tax: Number(slctedSer?.tax ?? 0),
        servicePrice: slctedSer?.servicePrice,
        serviceCharge: slctedSer?.serviceCharge,
        description: slctedSer?.description,
        hsnSacCode: slctedSer?.sacCode,
        variants,
        sampleType: slctedSer?.sampleType,
        doneAt: slctedSer?.doneAt,
        modality: slctedSer?.modality ?? null,
        region: slctedSer?.region ?? [],
        device: slctedSer?.device,
        processingTime: slctedSer?.processingTime,
        type: slctedSer?.type,
      };
      setServiceValues(reqObj);
      setServiceId(id);
      setModVisible(!modVisible);
    }
  };

  const handleAction = (value) => {
    if (value === "Disable" || value === "Enable") {
      if (!tableServices?.find((li) => li?.selected)) return;
      const ids = tableServices
        ?.filter((li) => li?.selected)
        ?.map((li) => li?.serviceId);
      dispatch(
        updateServiceStatusByIds({
          ids,
          active:
            tableServices?.find((li) => li?.selected)?.active === "Y"
              ? false
              : true,
        })
      ).then((res) => {
        if (res?.payload) {
          onServiceApiCall(page);
          // dispatch(
          //   getServices(
          //     `?page=${page}&itemSize=${rowsPerPage}&search=${searchValue}`
          //   )
          // );
        }
      });
    }
  };

  const getServiceCategories = () => {
    if (serviceCategories?.length === 0 || !serviceCategories) return [];
    const uniqList = uniqBy(serviceCategories, "category");
    if (uniqList?.length > 0) {
      const reqList = uniqList?.map((cat) => ({
        ...cat,
        name: cat?.category,
        value: cat?.category,
      }));
      return reqList;
    }
    return [];
  };

  const getSubCategoriesByCategory = (value) => {
    const groupData = groupBy(serviceCategories, "category");
    let reqList = [];
    if (groupData?.[value]?.length > 0) {
      reqList = groupData?.[value]?.map((cat) => ({
        ...cat,
        name: cat?.subCategory,
        value: cat?.subCategory,
      }));
    }
    return reqList;
  };

  const handleConsumOpen = () => {
    setConsumOpen(!consumOpen);
  };

  const handleAdminOpen = () => {
    setAdminOpen(!adminOpen);
  };

  const getStockBatch = (stockId, batchId) => {
    const selStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const reqBatc = selStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return reqBatc;
  };

  const handleConsumDelete = (ind, detailId = null) => {
    let reqList = [];
    if (serviceId && detailId) {
      reqList = variantValues?.consumList?.map((li, i) => {
        if (i === ind) {
          const reqAlter = (li?.alternates ?? [])
            ?.filter((al) => al?.delete && !al?.detailId)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...li, delete: true, alternates: reqAlter };
        }
        return li;
      });
    } else {
      reqList = variantValues?.consumList
        ?.filter((li, i) => i !== ind)
        ?.map((li, i) => {
          return { ...li, i };
        });
    }
    setVariantValues({ ...variantValues, consumList: reqList });
  };

  const handleConsumChange = (name, value, ind, addObj) => {
    const reqList = variantValues?.consumList?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.nameErr = "";
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.cost = reqCost;
          }
          if (addObj?.serviceId) {
            const reqService = servicesList?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks?.data
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              (Number(reqBatch?.unitSellingPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                servicesList?.data?.find(
                  (ser) => ser?.serviceId === li?.serviceId
                )?.servicePrice
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        return reqObj;
      }
      return li;
    });
    setVariantValues({ ...variantValues, consumList: reqList });
  };

  const handleAddTask = (typ) => {
    let consumList = variantValues?.consumList;
    let presList = variantValues?.presList;
    let prescriptions = variantValues?.prescriptions;
    if (typ === "consum") {
      const reqList = [
        ...variantValues?.consumList,
        { ...initItem, i: variantValues?.consumList?.length },
      ];
      consumList = reqList;
    }
    if (typ === "pres") {
      const reqList = [
        ...variantValues?.presList,
        { ...initItem, i: variantValues?.presList?.length },
      ];
      presList = reqList;
    }
    if (typ === "prescriptions") {
      const reqList = [
        ...(variantValues?.prescriptions ?? []),
        { ...initItem, i: variantValues?.prescriptions?.length ?? 0 },
      ];
      prescriptions = reqList;
    }
    setVariantValues({ ...variantValues, consumList, presList, prescriptions });
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
      name: btch?.batchNo,
      value: btch?.batchNo,
      batchId: btch?.batchId,
      salesUom: btch?.salesUom,
      unitSellingPrice: btch?.unitSellingPrice,
      purchaseUom: btch?.purchaseUom,
      packageUom: btch?.packageUom,
      dosage: btch?.dosage ?? "",
      dosageType: btch?.dosageType ?? null,
    }));
    return filteredBatches;
  };

  const getList = (isPres = false) => {
    let reqList = [];
    if (isPres) {
      reqList = stocks?.data?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          dta?.billable &&
          (dta?.category?.toLowerCase() === "deworming" ||
            dta?.category?.toLowerCase() === "diet" ||
            dta?.category?.toLowerCase() === "flea & tick treatment" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "medication" ||
            dta?.category?.toLowerCase() === "nutrition and supplements" ||
            dta?.category?.toLowerCase() === "other parasite treatment" ||
            dta?.category?.toLowerCase() === "vaccines")
        );
      });
    } else {
      reqList = stocks?.data?.filter((dta) => {
        return (
          dta?.active === "Y" &&
          dta?.billable &&
          (dta?.category?.toLowerCase() === "general consumables" ||
            dta?.category?.toLowerCase() === "medical supplies" ||
            dta?.category?.toLowerCase() === "surgical supplies" ||
            dta?.category?.toLowerCase() === "lab consumables" ||
            dta?.category?.toLowerCase() === "lab supplies" ||
            dta?.category?.toLowerCase() === "cleaning supplies" ||
            dta?.category?.toLowerCase() === "grooming & hygiene care" ||
            dta?.category?.toLowerCase() === "fluid therapy" ||
            dta?.category?.toLowerCase() === "mortuary")
        );
      });
    }
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const getPresList = () => {
    const reqList = stocks?.data?.filter((dta) => {
      return (
        dta?.billable &&
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care")
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const handleChangeAdminsterValue = (name, value, ind, addObj) => {
    const reqList = variantValues?.presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.data?.find(
              (stc) => stc?.stockId === addObj?.stockId
            )?.stockBatch?.[0];
            const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
            reqObj.dosage =
              getBatchList(addObj?.stockId)?.[0]?.dosage ?? reqPack?.[1];

            const priceRatio =
              Number(
                getBatchList(addObj?.stockId)?.[0]?.dosage ?? reqPack?.[1] ?? 0
              ) / Number(reqPack?.[1]);
            const reqPrice =
              (Number(reqBatch?.unitSellingPrice) ?? 0) *
              Number(priceRatio ?? 0);
            reqObj.cost = reqPrice;
          }
          if (pl?.dosage) {
            if (addObj?.stockId) {
              const reqBatch = stocks?.data?.find(
                (stc) => stc?.stockId === addObj?.stockId
              )?.stockBatch?.[0];
              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio = Number(pl?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.cost = reqPrice;
            }
          }
        }
        if (name === "batchNumber" && addObj) {
          reqObj.batchId = addObj?.batchId;
          reqObj.cost = getBatchList(pl?.stockId)?.find(
            (bat) => bat?.batchId === addObj?.batchId
          )?.unitSellingPrice;
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        if (name === "dosage") {
          reqObj.dosErr =
            value?.length > 0
              ? Number(value) > 0
                ? ""
                : "Value must be positive"
              : "This field is reqired";
          if (pl?.stockId) {
            const reqBatch = stocks?.data?.find(
              (stc) => stc?.stockId === pl?.stockId
            )?.stockBatch?.[0];
            const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
            const priceRatio = Number(value) / Number(reqPack?.[1]);
            const reqPrice =
              (Number(reqBatch?.unitSellingPrice) ?? 0) *
              Number(priceRatio ?? 0);
            reqObj.cost = reqPrice;
          }
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setVariantValues({ ...variantValues, presList: reqList });
  };

  const handleChangePrescripValue = (name, value, ind, addObj) => {
    const reqList = variantValues?.prescriptions?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.data?.find(
              (stc) => stc?.stockId === addObj?.stockId
            )?.stockBatch?.[0];
            const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
            reqObj.dosage =
              getBatchList(addObj?.stockId)?.[0]?.dosage ?? reqPack?.[1];
            reqObj.cost = Number(reqBatch?.unitSellingPrice) ?? 0;
          } else {
            reqObj.cost = 0;
          }
        }
        if (name === "batchNumber" && addObj) {
          reqObj.batchId = addObj?.batchId;
          reqObj.cost = getBatchList(pl?.stockId)?.find(
            (bat) => bat?.batchId === addObj?.batchId
          )?.unitSellingPrice;
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        if (name === "qty") {
          reqObj.qtyErr =
            value?.length > 0
              ? Number(value) > 0
                ? ""
                : "Value must be positive"
              : "This field is reqired";
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setVariantValues({ ...variantValues, prescriptions: reqList });
  };

  const deleteAdministerByIndex = (ind, presId = null) => {
    let reqList = [];
    if (serviceId && presId) {
      reqList = variantValues?.presList?.map((rl, i) => {
        if (i === ind) {
          const reqAlters = (rl?.alternates ?? [])
            ?.filter((al) => al?.delete && !al?.prescriptionId)
            ?.map((al) => ({ ...al, delete: true }));
          return { ...rl, delete: true, alternates: reqAlters };
        }
        return rl;
      });
    } else {
      reqList = variantValues?.presList
        ?.filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    setVariantValues({ ...variantValues, presList: reqList });
  };

  const deletePricripByIndex = (ind, presId = null) => {
    let reqList = [];
    if (serviceId && presId) {
      reqList = variantValues?.prescriptions?.map((rl, i) => {
        if (i === ind) {
          return { ...rl, delete: true };
        }
        return rl;
      });
    } else {
      reqList = variantValues?.prescriptions
        ?.filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    setVariantValues({ ...variantValues, prescriptions: reqList });
  };

  const addVariant = () => {
    const reqObj = { ...serviceValues };
    const prevVariants = serviceValues?.variants ?? [];
    prevVariants.push({
      ...(serviceValues?.variants?.[0] ?? {}),
      variantId: "",
      variantNumber: "",
      variantName: "",
      serviceCharge: "",
      servicePrice: "",
      i: prevVariants?.length ?? 0,
    });
    reqObj.variants = prevVariants;
    setServiceValues(reqObj);
  };

  const handleDeleteVariant = (ind) => {
    if (serviceValues?.variants?.length === 1) return;
    const reqObj = { ...serviceValues };
    const isPrevVar = serviceValues?.variants?.find(
      (li, i) => li?.i !== ind && li?.variantId
    );
    if (isPrevVar) {
      const reqVarnts = serviceValues?.variants?.map((li, i) => {
        if (li?.i !== ind) {
          const reqConList = li?.consumList?.map((cl) => {
            const reqAlters = (cl?.alternates ?? [])
              ?.filter((al) => !al?.detailId && al?.delete)
              ?.map((li) => ({ ...li, delete: true }));
            return { ...cl, delete: true, alternates: reqAlters };
          });
          const reqPresList = li?.presList?.map((pl) => {
            const reqAlters = (pl?.alternates ?? [])
              ?.filter((al) => !al?.detailId && al?.delete)
              ?.map((li) => ({ ...li, delete: true }));
            return { ...pl, delete: true, alternates: reqAlters };
          });
          return {
            ...li,
            delete: true,
            consumList: reqConList,
            presList: reqPresList,
          };
        }
        return li;
      });
      reqObj.variants = reqVarnts;
    } else {
      reqObj.variants = serviceValues?.variants
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
    }
    setServiceValues(reqObj);
  };

  const onChangeVarValue = (name, value, ind) => {
    const reqObj = {
      ...serviceValues,
      variants: serviceValues?.variants?.map((li) => {
        if (li?.i === ind) {
          const newObj = { ...li, [name]: value };
          if (name === "variantName") {
            newObj.nameErr = value?.length > 0 ? "" : "This field is required";
          }
          if (name === "estimatedDuration") {
            newObj.durError =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
          }
          if (name === "serviceCharge") {
            newObj.chargeErr =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
            newObj.serPriceErr =
              value?.length > 0
                ? Number(value) >= 0
                  ? ""
                  : "Value must be positive"
                : "This field is required";
            const reqSellPrce =
              Number(value) +
              getTotalEstimatedCost([
                ...(li?.consumList ?? []),
                ...(li?.presList ?? []),
              ]);
            newObj.servicePrice = reqSellPrce;
            if (
              getTotalEstimatedCost([
                ...(li?.consumList ?? []),
                ...(li?.presList ?? []),
              ]) >= Number(value)
            ) {
              newObj.serPriceErr = "";
            }
          }
          if (name === "servicePrice") {
            newObj.serPriceErr =
              value?.length > 0
                ? Number(value) < 0
                  ? "Value must be positive"
                  : ""
                : "This field is required";
          }
          if (name === "region") {
            newObj.regionErr =
              value?.length > 0 ? "" : "This field is required";
          }
          return newObj;
        }
        return li;
      }),
    };

    setServiceValues(reqObj);
  };

  const handleConsumAlternates = (ind, value) => {
    const reqObj = { ...variantValues };
    reqObj.consumList = variantValues?.consumList?.map((li) => {
      if (li?.i === ind) {
        const reqInnerObj = { ...li, modVsble: value };
        setAlternates(
          !li?.alternates || li?.alternates?.length === 0
            ? [{ ...li, isDefault: true, i: 0 }]
            : li?.alternates
        );
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
  };

  const getOpenedConsum = () => {
    return variantValues?.consumList?.find((li) => li?.modVsble);
  };

  const getOpenedAdmin = () => {
    return variantValues?.presList?.find((li) => li?.modVsble);
  };

  const onCloseConsumMod = () => {
    const reqCon = getOpenedConsum();
    if (reqCon) handleConsumAlternates(reqCon?.i, false);
  };

  const onCloseAdminMod = () => {
    const reqAdmn = getOpenedAdmin();
    if (reqAdmn) handleAdminAlternates(reqAdmn?.i, false);
  };

  const handleAddConsum = () => {
    setAlternates([
      ...alternates,
      { ...initItem, isDefault: false, i: alternates?.length },
    ]);
  };

  const onDeleteAlterConsum = (ind, detId = null) => {
    let reqAlternates = [];
    if (detId) {
      reqAlternates = alternates?.map((li, i) => {
        if (li?.i === ind) return { ...li, delete: true };
        return li;
      });
    } else {
      reqAlternates = alternates
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
      if (!reqAlternates?.find((li) => li?.isDefault)) {
        reqAlternates = reqAlternates?.map((li, i) => {
          if (i === 0) return { ...li, isDefault: true };
          return li;
        });
      }
    }
    setAlternates(reqAlternates);
  };

  const onChangeConsumDefault = (ind) => {
    const reqCon = getOpenedConsum();
    const reqVar = alternates?.find((li) => li?.i === ind);
    const reqAlternates = alternates?.map((li) => ({
      ...li,
      isDefault: li?.i === ind,
    }));
    const reqConsumList = variantValues?.consumList?.map((li) => {
      if (li?.i === reqCon?.i) {
        return {
          ...li,
          name: reqVar?.name,
          quantity: reqVar?.quantity,
          stockId: reqVar?.stockId ?? null,
          estimatedCost: reqVar?.cost,
          cost: reqVar?.cost,
        };
      }
      return li;
    });
    setAlternates(reqAlternates);
    setVariantValues({ ...variantValues, consumList: reqConsumList });
  };

  const onChangeConsumValue = (name, value, ind, addObj) => {
    const reqAlternates = alternates?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.nameErr = "";
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.cost = reqCost;
          }
          if (addObj?.serviceId) {
            const reqService = servicesList?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          reqObj.qtyErr = value?.length > 0 ? "" : "This field is required";
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks?.data
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              (Number(reqBatch?.unitSellingPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                servicesList?.data?.find(
                  (ser) => ser?.serviceId === li?.serviceId
                )?.servicePrice
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        if (li?.isDefault) {
          const reqCon = getOpenedConsum();
          const reqConsumList = variantValues?.consumList?.map((li) => {
            if (li?.i === reqCon?.i) {
              return {
                ...li,
                name: reqObj?.name,
                quantity: reqObj?.quantity,
                stockId: reqObj?.stockId ?? null,
                estimatedCost: reqObj?.cost,
                cost: reqObj?.cost,
              };
            }
            return li;
          });
          setVariantValues({ ...variantValues, consumList: reqConsumList });
        }
        return reqObj;
      }
      return li;
    });
    setAlternates(reqAlternates);
  };

  const handleSaveConsum = () => {
    const reqCon = getOpenedConsum();
    const reqObj = { ...variantValues };
    const reqAlters = alternates?.map((al) => {
      const errs = validateConsumItem(al);
      return { ...al, ...errs };
    });
    if (
      reqAlters?.some((li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0)
    ) {
      return setAlternates(reqAlters);
    }
    reqObj.consumList = variantValues?.consumList?.map((li) => {
      if (li?.i === reqCon?.i) {
        const reqAlts = reqAlters?.sort((a, b) => b?.isDefault - a?.isDefault);
        const reqInnerObj = { ...li, modVsble: false, alternates: reqAlts };
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
    setAlternates([]);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      })
    );
  };

  const handleSaveAdmin = () => {
    const reqAdm = getOpenedAdmin();
    const reqObj = { ...variantValues };
    const reqAlters = alternates?.map((al) => {
      const errs = validatePresItem(al);
      return { ...al, ...errs };
    });
    if (
      reqAlters?.some(
        (li) =>
          li?.nameErr?.length > 0 ||
          li?.dosErr?.length > 0 ||
          li?.routeErr?.length > 0
      )
    ) {
      return setAlternates(reqAlters);
    }
    reqObj.presList = variantValues?.presList?.map((li) => {
      if (li?.i === reqAdm?.i) {
        const reqAlts = alternates?.sort((a, b) => b?.isDefault - a?.isDefault);
        const reqInnerObj = { ...li, modVsble: false, alternates: reqAlts };
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
    setAlternates([]);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      })
    );
  };

  const handleAdminAlternates = (ind, value) => {
    const reqObj = { ...variantValues };
    reqObj.presList = variantValues?.presList?.map((li) => {
      if (li?.i === ind) {
        const reqInnerObj = { ...li, modVsble: value };
        setAlternates(
          !li?.alternates || li?.alternates?.length === 0
            ? [{ ...li, isDefault: true, i: 0 }]
            : li?.alternates
        );
        return reqInnerObj;
      }
      return li;
    });
    setVariantValues(reqObj);
  };

  const handleAddAdmin = () => {
    setAlternates([
      ...alternates,
      { ...initItem, isDefault: false, i: alternates?.length },
    ]);
  };

  const onChangeAdminDefault = (ind) => {
    const reqAdmn = getOpenedAdmin();
    const reqVar = alternates?.find((li) => li?.i === ind);
    const reqAlternates = alternates?.map((li) => ({
      ...li,
      isDefault: li?.i === ind,
    }));
    const reqAdminList = variantValues?.presList?.map((li) => {
      if (li?.i === reqAdmn?.i) {
        return {
          ...li,
          name: reqVar?.name,
          quantity: reqVar?.quantity,
          stockId: reqVar?.stockId ?? null,
          estimatedCost: reqVar?.cost,
          cost: reqVar?.cost,
          route: reqVar?.route,
          dosage: reqVar?.dosage,
        };
      }
      return li;
    });
    setAlternates(reqAlternates);
    setVariantValues({ ...variantValues, presList: reqAdminList });
  };

  const onDeleteAlterAdmin = (ind, detId = null) => {
    let reqAlternates = [];
    if (detId) {
      reqAlternates = alternates?.map((li, i) => {
        if (li?.i === ind) return { ...li, delete: false };
        return li;
      });
    } else {
      reqAlternates = alternates
        ?.filter((li) => li?.i !== ind)
        ?.map((li, i) => ({ ...li, i }));
      if (!reqAlternates?.find((li) => li?.isDefault)) {
        reqAlternates = reqAlternates?.map((li, i) => {
          if (i === 0) return { ...li, isDefault: true };
          return li;
        });
      }
    }
    setAlternates(reqAlternates);
  };

  const onChangeAdminValue = (name, value, ind, addObj) => {
    const reqAlternates = alternates?.map((li) => {
      if (li?.i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "route") {
          reqObj.routeErr = !value ? "This field is required" : "";
        }
        if (name === "name" && addObj) {
          reqObj.nameErr = "";
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (li?.dosage) {
            if (addObj?.stockId) {
              const reqBatch = stocks?.data?.find(
                (stc) => stc?.stockId === addObj?.stockId
              )?.stockBatch?.[0];
              const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
              const priceRatio = Number(li?.dosage ?? 0) / Number(reqPack?.[1]);
              const reqPrice =
                (Number(reqBatch?.unitSellingPrice) ?? 0) *
                Number(priceRatio ?? 0);
              reqObj.cost = reqPrice;
            }
          }
        }
        if (name === "dosage") {
          reqObj.dosErr =
            value?.length > 0
              ? Number(value) > 0
                ? ""
                : "Value must be positive"
              : "This field is reqired";
          if (li?.stockId) {
            const reqBatch = stocks?.data?.find(
              (stc) => stc?.stockId === li?.stockId
            )?.stockBatch?.[0];
            const reqPack = reqBatch?.packageUom?.match(/^(\d+)(.+)/);
            const priceRatio = Number(value) / Number(reqPack?.[1]);
            const reqPrice =
              (Number(reqBatch?.unitSellingPrice) ?? 0) *
              Number(priceRatio ?? 0);
            reqObj.cost = reqPrice;
          }
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        if (li?.isDefault) {
          const reqAdmn = getOpenedAdmin();
          const reqAdminList = variantValues?.presList?.map((li) => {
            if (li?.i === reqAdmn?.i) {
              return {
                ...li,
                name: reqObj?.name,
                quantity: reqObj?.quantity,
                stockId: reqObj?.stockId ?? null,
                estimatedCost: reqObj?.cost,
                cost: reqObj?.cost,
                route: reqObj?.route,
                dosage: reqObj?.dosage,
              };
            }
            return li;
          });
          setVariantValues({ ...variantValues, presList: reqAdminList });
        }
        return reqObj;
      }
      return li;
    });
    setAlternates(reqAlternates);
  };

  const getModalList = (value = false) => {
    const list = getList(value);
    if (alternates?.length === 0 || !alternates) return list;
    const stockIdsToExclude = new Set(alternates?.map((item) => item?.stockId));
    const reqList = list?.filter(
      (item) => !stockIdsToExclude?.has(item?.stockId)
    );
    return reqList;
  };

  const handleView = (dta) => {
    const reqVarnts = serviceValues?.variants?.map((li) => {
      if (li?.i === dta?.i) return { ...li, modVsble: true };
      return li;
    });
    setVariantValues({
      ...variantValues,
      consumList: dta?.consumList ?? [],
      presList: dta?.presList ?? [],
      prescriptions: dta?.prescriptions ?? [],
    });
    setSlctedVariant(dta);
    setServiceValues({ ...serviceValues, variants: reqVarnts });
  };

  const handleVariantClose = (dta) => {
    const reqVarnts = serviceValues?.variants?.map((li) => {
      if (li?.i === slctedVariant?.i) {
        return { ...li, modVsble: false };
      }
      return li;
    });
    setSlctedVariant(null);
    setServiceValues({ ...serviceValues, variants: reqVarnts });
  };

  const saveVariant = () => {
    let isValueErr = false;
    const reqVariants = serviceValues?.variants?.map((li) => {
      if (li?.i === slctedVariant?.i) {
        const reqObj = { ...li };
        if (variantValues?.consumList?.length > 0) {
          reqObj.consumList = variantValues?.consumList?.map((cl) => {
            const errs = validateConsumItem(cl);
            return { ...cl, ...errs };
          });
        }
        if (variantValues?.presList?.length > 0) {
          reqObj.presList = variantValues?.presList?.map((pl) => {
            const errs = validatePresItem(pl);
            return { ...pl, ...errs };
          });
        }
        if (variantValues?.prescriptions?.length > 0) {
          reqObj.prescriptions = variantValues?.prescriptions?.map((pl) => {
            const errs = validatePrescripItem(pl);
            return { ...pl, ...errs };
          });
        }
        if (
          reqObj?.consumList?.some(
            (li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0
          ) ||
          reqObj?.presList?.some(
            (li) =>
              li?.nameErr?.length > 0 ||
              li?.dosErr?.length > 0 ||
              li?.routeErr?.length > 0
          ) ||
          reqObj?.prescriptions?.some(
            (li) => li?.nameErr?.length > 0 || li?.qtyErr?.length > 0
          )
        ) {
          isValueErr = true;
          setVariantValues({
            ...variantValues,
            consumList: reqObj?.consumList,
            presList: reqObj?.presList,
            prescriptions: reqObj?.prescriptions,
          });
        }
        const reqSellPrce =
          Number(li?.serviceCharge ?? 0) +
          getTotalEstimatedCost([
            ...(variantValues?.consumList ?? []),
            ...(variantValues?.presList ?? []),
          ]);
        reqObj.servicePrice = reqSellPrce;
        return reqObj;
      }
      return li;
    });
    if (isValueErr) return;
    setServiceValues({ ...serviceValues, variants: reqVariants });
    setVariantValues(initVariants);
    setSlctedVariant(null);
    dispatch(
      showSnackBar({
        message: "Changes updated successfully!",
        type: "success",
      })
    );
  };

  const checkEstDurationIsMandatory = () => {
    let result = false;
    if (
      (serviceValues?.category?.value === "Radiology" &&
        (serviceValues?.subCategory?.value === "Imaging" ||
          serviceValues?.subCategory?.value === "Endoscopy")) ||
      (serviceValues?.category?.value === "Hygiene & Grooming" &&
        (serviceValues?.subCategory?.value === "Bathing" ||
          serviceValues?.subCategory?.value === "Spa/Pampering Services"))
    ) {
      result = true;
    }
    return result;
  };

  const getRegionListBasedOnModality = (modality = null) => {
    if (modality) {
      return regionList?.filter((li) => li?.modality === modality);
    }
    return [];
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: {},
      });
    });
    onServiceApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = { ...initFilter, visible: true };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onServiceApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onServiceApiCall(1);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqValue = {
      ...filterValues?.values,
      [name?.trim()?.replace(/,$/, "")]: value,
    };
    if (name === "Category") {
      reqValue["Sub-category"] = [];
    }
    const reqObj = { ...filterValues, values: reqValue };
    setFilterValues(reqObj);
  };

  return (
    <Container maxWidth="xl">
      <div className="com-mar back-white pv10">
        <div className="flex-row-ali-cen flex-center mt10">
          <div className="w15Per">
            <CustomTextField
              placeholder="Procedure Name"
              fullWidth
              name="name"
              backgroundColor={AppColors.lightBlue2}
              value={searchValues?.name}
              handleChange={onSearchChange}
              label="Procedure Name"
            />
          </div>
          <div className="w15Per ml20">
            <Select
              list={getServiceCategories()}
              value={searchValues?.category}
              name="category"
              handleChange={onSearchChange}
              label="Category"
              select
              backgroundColor={AppColors.lightBlue2}
            />
            {/* <CustomTextField
              placeholder="Variant ID"
              fullWidth
              name="variantId"
              backgroundColor={AppColors.lightBlue2}
              value={searchValues?.variantId}
              handleChange={onSearchChange}
              label="Variant ID"
            /> */}
          </div>
          <div className="w15Per ml20">
            <Select
              list={getSubCategoriesByCategory(searchValues?.category)}
              value={searchValues?.subCategory}
              name="subCategory"
              handleChange={onSearchChange}
              label="Sub-category"
              select
              backgroundColor={AppColors.lightBlue2}
            />
            {/* <CustomTextField
              placeholder="Variant Name"
              fullWidth
              name="variantName"
              backgroundColor={AppColors.lightBlue2}
              value={searchValues?.variantName}
              handleChange={onSearchChange}
              label="Variant Name"
            /> */}
          </div>
          <div className="w15Per ml20">
            <Select
              list={ServiceTypes}
              value={searchValues?.type}
              handleChange={onSearchChange}
              name="type"
              select
              label="Type"
              backgroundColor={AppColors.lightBlue2}
            />
          </div>
          <div
            className="flex-row-ali-cen ml20 filter cursor"
            onClick={() => onFilterChange("visible", true)}
          >
            <TuneIcon sx={{ color: AppColors.appPrimary }} />
            <Typography className="font-medium fs12 blue-color ml10">
              {filterValues?.selectedList?.length > 0
                ? `${filterValues?.selectedList?.length} `
                : ""}
              Filter
            </Typography>
          </div>
          <div className="ml20">
            <CustomButton text="Reset" onClick={onReset} smallBtn redBtn />
          </div>
          <div className="ml20">
            <CustomButton text="Create" smallBtn onClick={handleOpen} />
          </div>
          <div className="ml10">
            <SplitButton
              list={
                tableServices?.find((li) => li?.active === "Y" && li?.selected)
                  ? ["Disable"]
                  : ["Enable"]
              }
              handleClickItem={handleAction}
            />
          </div>
        </div>
        <Typography className="font-medium fs12 gray28 ph20 mt10">
          Number of Services: {servicesList?.totalRecords}
        </Typography>

        <Table
          columns={tableHeaders}
          datas={getSupplierTable()}
          page={page}
          rowsPerPage={rowsPerPage}
          totalRecords={servicesList?.totalRecords}
          handleChangePage={handleChangePage}
          grey
          product={true}
        />

        <CustomModal
          open={modVisible}
          onClose={handleClose}
          header={serviceId ? "Edit" : "Create"}
          modal
          modalWidth={90}
        >
          <div className="scroll-80vh">
            <Grid container spacing={2} className="ph20">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs16 blue-color">
                  Service Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomCheckbox
                  label="Disabled"
                  checked={serviceValues?.active}
                  onChange={() =>
                    handleChange("active", !serviceValues?.active)
                  }
                />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">
                  Type <span className="red-color">*</span>
                </div> */}
                <div className="mb20">
                  <Select
                    list={ServiceTypes}
                    value={serviceValues?.type}
                    handleChange={(e) => handleChange("type", e?.target?.value)}
                    name="type"
                    select
                    error={serviceErrors?.type}
                    helperText={serviceHelps?.type}
                    label="Type *"
                  />
                </div>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">
                  Category <span className="red-color">*</span>
                </div> */}
                <div className="mb20">
                  <Select
                    list={getServiceCategories()}
                    value={serviceValues?.category}
                    handleChange={(e, value) => {
                      handleChange("category", value);
                    }}
                    name="category"
                    search
                    error={serviceErrors?.category}
                    helperText={serviceHelps?.category}
                    label="Category *"
                  />
                </div>
              </Grid>
              {serviceValues?.category?.value !== "Radiology" ? (
                <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                  {/* <div className="txt-semi-bold fs14 light-grey">
                  Sub-Category <span className="red-color">*</span>
                </div> */}
                  <div className="mb20">
                    <Select
                      list={getSubCategoriesByCategory(
                        serviceValues?.category?.value
                      )}
                      value={serviceValues?.subCategory}
                      handleChange={(e, value) => {
                        handleChange("subCategory", value);
                      }}
                      name="subCategory"
                      search
                      error={serviceErrors?.subCategory}
                      helperText={serviceHelps?.subCategory}
                      label="Sub-Category *"
                    />
                  </div>
                </Grid>
              ) : null}
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">
                  Procedure name <span className="red-color">*</span>
                </div> */}
                <div className="mb20">
                  {serviceValues?.category?.value === "Radiology" ? (
                    <Select
                      list={modalities}
                      value={serviceValues?.serviceName}
                      handleChange={(e) =>
                        handleChange("serviceName", e?.target?.value)
                      }
                      name="serviceName"
                      select
                      error={serviceErrors?.serviceName}
                      helperText={serviceHelps?.serviceName}
                      label="Modality/Procedure Name *"
                    />
                  ) : (
                    <CustomTextField
                      name="serviceName"
                      fullWidth
                      helperText={serviceHelps?.serviceName}
                      error={serviceErrors?.serviceName}
                      value={serviceValues?.serviceName}
                      handleChange={(e) =>
                        handleChange("serviceName", e?.target?.value)
                      }
                      label="Procedure name"
                      required={true}
                    />
                  )}
                </div>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">SAC Code</div> */}
                <div className="mb20">
                  <CustomTextField
                    name="hsnSacCode"
                    fullWidth
                    helperText={serviceHelps?.hsnSacCode}
                    error={serviceErrors?.hsnSacCode}
                    value={serviceValues?.hsnSacCode}
                    handleChange={(e) =>
                      handleChange("hsnSacCode", e?.target?.value)
                    }
                    label="SAC Code"
                  />
                </div>
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                {/* <div className="txt-semi-bold fs14 light-grey">Tax Applicability</div> */}
                <div className="mb20">
                  <Select
                    list={yesNoValueList}
                    value={serviceValues?.taxApplicability}
                    handleChange={(e) =>
                      handleChange("taxApplicability", e?.target?.value)
                    }
                    name="taxApplicability"
                    select
                    error={serviceErrors?.taxApplicability}
                    helperText={serviceHelps?.taxApplicability}
                    label="Tax Applicability *"
                  />
                </div>
              </Grid>
              {serviceValues?.taxApplicability?.toLowerCase() === "yes" ? (
                <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                  {/* <div className="txt-semi-bold fs14 light-grey">Tax %</div> */}
                  <div className="mb20">
                    <CustomTextField
                      name="tax"
                      fullWidth
                      helperText={serviceHelps?.tax}
                      error={serviceErrors?.tax}
                      value={serviceValues?.tax}
                      handleChange={(e) =>
                        handleChange("tax", e?.target?.value)
                      }
                      label="Tax % *"
                      type="number"
                    />
                  </div>
                </Grid>
              ) : null}
              {serviceValues?.category?.value === "Lab" ||
              serviceValues?.category?.value === "Radiology" ? (
                <>
                  {serviceValues?.category?.value === "Lab" && (
                    <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                      <div className="mb20">
                        <Select
                          list={sampleTypes}
                          value={serviceValues?.sampleType}
                          handleChange={(e) =>
                            handleChange("sampleType", e?.target?.value)
                          }
                          name="sampleType"
                          select
                          error={serviceErrors?.sampleType}
                          helperText={serviceHelps?.sampleType}
                          label="Sample Type"
                        />
                      </div>
                    </Grid>
                  )}
                  {serviceValues?.category?.value === "Radiology" && (
                    <>
                      {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                        <div className="mb20">
                          <Select
                            list={modalities}
                            value={serviceValues?.modality}
                            handleChange={(e) =>
                              handleChange("modality", e?.target?.value)
                            }
                            name="modality"
                            select
                            error={serviceErrors?.modality}
                            helperText={serviceHelps?.modality}
                            label="Modality *"
                          />
                        </div>
                      </Grid> */}
                      {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                        <div className="mb20">
                          <Select
                            list={getRegionListBasedOnModality(
                              serviceValues?.modality?.length > 0
                                ? serviceValues?.modality
                                : null
                            )}
                            value={serviceValues?.region}
                            handleChange={(e) => handleChange("region", e)}
                            name="region"
                            reason
                            error={serviceErrors?.region}
                            helperText={serviceHelps?.region}
                            label="Region *"
                          />
                        </div>
                      </Grid> */}
                      {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                        <div className="mb20">
                          <Select
                            list={devices}
                            value={serviceValues?.device}
                            handleChange={(e) =>
                              handleChange("device", e?.target?.value)
                            }
                            name="device"
                            select
                            error={serviceErrors?.device}
                            helperText={serviceHelps?.device}
                            label="Device"
                          />
                        </div>
                      </Grid> */}
                    </>
                  )}
                  {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                    <div className="mb20">
                      <Select
                        list={doneAtList}
                        value={serviceValues?.doneAt}
                        handleChange={(e) =>
                          handleChange("doneAt", e?.target?.value)
                        }
                        name="doneAt"
                        select
                        error={serviceErrors?.doneAt}
                        helperText={serviceHelps?.doneAt}
                        label="Done At"
                      />
                    </div>
                  </Grid> */}
                  {/* <Grid item xs={6} sm={6} md={4} lg={4} xl={4}>
                    <div className="mb20">
                      <CustomTextField
                        name="processingTime"
                        fullWidth
                        helperText={serviceHelps?.processingTime}
                        error={serviceErrors?.processingTime}
                        value={serviceValues?.processingTime}
                        handleChange={(e) =>
                          handleChange("processingTime", e?.target?.value)
                        }
                        label="Processing Time"
                      />
                    </div>
                  </Grid> */}
                </>
              ) : null}

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="font-bold fs16 blue-color">
                  Variants
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card sx={cardSty}>
                  <div style={{ overflowX: "auto", width: "100%" }}>
                    <div
                      style={{
                        minWidth:
                          1390 +
                          (serviceValues?.category?.value === "Radiology"
                            ? 600
                            : serviceValues?.category?.value === "Lab"
                            ? 400
                            : 0),
                      }}
                    >
                      <div className="flex-row mh10">
                        <div style={{ width: 150 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Variant Id
                          </Typography>
                        </div>
                        <div style={{ width: 300 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Variant Name <span className="red-color">*</span>
                          </Typography>
                        </div>
                        <div style={{ width: 150 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Est Cost
                          </Typography>
                        </div>
                        <div style={{ width: 250 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Estimated Duration (In Minutes){" "}
                            {checkEstDurationIsMandatory() ? (
                              <span className="red-color">*</span>
                            ) : null}
                          </Typography>
                        </div>
                        <div style={{ width: 200 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Service Charge <span className="red-color">*</span>
                          </Typography>
                        </div>
                        <div style={{ width: 200 }}>
                          <Typography className="txt-semi-bold fs12 blue-color">
                            Final Selling Price{" "}
                            <span className="red-color">*</span>
                          </Typography>
                        </div>
                        {serviceValues?.category?.value === "Radiology" && (
                          <div style={{ width: 200 }}>
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Region <span className="red-color">*</span>
                            </Typography>
                          </div>
                        )}
                        {(serviceValues?.category?.value === "Radiology" ||
                          serviceValues?.category?.value === "Lab") && (
                          <>
                            <div style={{ width: 200 }}>
                              <Typography className="txt-semi-bold fs12 blue-color">
                                Device
                              </Typography>
                            </div>
                            <div style={{ width: 200 }}>
                              <Typography className="txt-semi-bold fs12 blue-color">
                                Done At
                              </Typography>
                            </div>
                          </>
                        )}
                        <div style={{ width: 70 }} />
                        <div style={{ width: 70 }} />
                      </div>
                      <div className="blue-hor-split mt5" />
                      {serviceValues?.variants
                        ?.filter((li) => !li?.delete)
                        ?.map((li, ind) => (
                          <div
                            className="flex-row mt10 plan-bor"
                            key={li?.i + "var"}
                          >
                            <div style={{ width: 150 }} className="pr10">
                              <CustomTextField
                                fullWidth
                                value={li?.variantNumber}
                                handleChange={(e) =>
                                  onChangeVarValue(
                                    "variantNumber",
                                    e?.target?.value,
                                    li?.i
                                  )
                                }
                              />
                            </div>
                            <div className="pr10" style={{ width: 300 }}>
                              <CustomTextField
                                fullWidth
                                value={li?.variantName}
                                error={!!li?.nameErr}
                                helperText={li?.nameErr}
                                handleChange={(e) =>
                                  onChangeVarValue(
                                    "variantName",
                                    e?.target?.value,
                                    li?.i
                                  )
                                }
                              />
                            </div>
                            <div style={{ width: 150 }}>
                              <Typography className="font-medium fs14 mt10">
                                Rs.{" "}
                                {Number(
                                  getTotalEstimatedCost([
                                    ...(li?.consumList ?? []),
                                    ...(li?.presList ?? []),
                                  ])
                                )?.toFixed(2)}
                              </Typography>
                            </div>
                            <div className="pr10" style={{ width: 250 }}>
                              <CustomTextField
                                fullWidth
                                value={li?.estimatedDuration}
                                error={!!li?.durError}
                                helperText={li?.durError}
                                handleChange={(e) =>
                                  onChangeVarValue(
                                    "estimatedDuration",
                                    e?.target?.value,
                                    li?.i
                                  )
                                }
                                type="number"
                              />
                            </div>
                            <div className="pr10" style={{ width: 200 }}>
                              <CustomTextField
                                fullWidth
                                value={li?.serviceCharge}
                                error={!!li?.chargeErr}
                                helperText={li?.chargeErr}
                                handleChange={(e) =>
                                  onChangeVarValue(
                                    "serviceCharge",
                                    e?.target?.value,
                                    li?.i
                                  )
                                }
                                type="number"
                              />
                            </div>
                            <div className="pr10" style={{ width: 200 }}>
                              <CustomTextField
                                fullWidth
                                value={li?.servicePrice}
                                error={!!li?.serPriceErr}
                                helperText={li?.serPriceErr}
                                handleChange={(e) =>
                                  onChangeVarValue(
                                    "servicePrice",
                                    e?.target?.value,
                                    li?.i
                                  )
                                }
                                type="number"
                              />
                            </div>
                            {serviceValues?.category?.value === "Radiology" && (
                              <div className="pr10" style={{ width: 200 }}>
                                <Select
                                  list={getRegionListBasedOnModality(
                                    serviceValues?.serviceName
                                  )}
                                  value={li?.region}
                                  handleChange={(e) =>
                                    onChangeVarValue("region", e, li?.i)
                                  }
                                  reason
                                  error={!!li?.regionErr}
                                  helperText={li?.regionErr}
                                />
                              </div>
                            )}
                            {(serviceValues?.category?.value === "Radiology" ||
                              serviceValues?.category?.value === "Lab") && (
                              <>
                                <div className="pr10" style={{ width: 200 }}>
                                  <Select
                                    list={devices}
                                    value={li?.device}
                                    handleChange={(e) =>
                                      onChangeVarValue(
                                        "device",
                                        e?.target?.value,
                                        li?.i
                                      )
                                    }
                                    name="device"
                                    select
                                  />
                                </div>
                                <div className="pr10" style={{ width: 200 }}>
                                  <Select
                                    list={doneAtList}
                                    value={li?.doneAt}
                                    handleChange={(e) =>
                                      onChangeVarValue(
                                        "doneAt",
                                        e?.target?.value,
                                        li?.i
                                      )
                                    }
                                    name="doneAt"
                                    select
                                  />
                                </div>
                              </>
                            )}
                            <div style={{ width: 70 }} className="mt5">
                              <div
                                className="cursor"
                                onClick={() => handleView(li)}
                              >
                                <div className="flex-center">
                                  <VisibilityIcon sx={plusBtn} />
                                </div>
                                <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                  View
                                </Typography>
                              </div>
                            </div>
                            <div style={{ width: 70 }} className="mt5">
                              {ind !== 0 ? (
                                <div
                                  className="cursor"
                                  onClick={() => handleDeleteVariant(li?.i)}
                                >
                                  <div className="flex-center">
                                    <DeleteOutlineIcon sx={delBtn} />
                                  </div>
                                  <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                    Delete
                                  </Typography>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ))}
                      <div
                        className="flex-row-ali-cen mt10 cursor"
                        onClick={addVariant}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs16 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                    </div>
                  </div>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <div className="txt-semi-bold fs14 light-grey">Remarks</div> */}
                <CustomTextField
                  name="description"
                  label="Remarks"
                  fullWidth
                  value={serviceValues?.description}
                  error={serviceErrors?.description}
                  helperText={serviceHelps?.description}
                  handleChange={(e) =>
                    handleChange("description", e?.target?.value)
                  }
                  multiline
                />
              </Grid>
            </Grid>

            <div className="mt30 mb20">
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                  <div className="flex1-end">
                    <div className="flex-row-ali-cen">
                      <div className="mr10">
                        <CustomButton
                          text="Cancel"
                          textBtn
                          onClick={handleClose}
                          color={AppColors.red}
                        />
                      </div>
                      <div className="ml10">
                        <CustomButton
                          text="Submit"
                          onClick={handleSubmit}
                          smallBtn
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          open={slctedVariant}
          onClose={handleVariantClose}
          header="Variant"
          modal
          modalWidth={90}
        >
          <div className="scroll-80vh ph20">
            <div className="flex-row-between-align-center">
              <div>
                <div className="report-selctd-bodr br10 ph15 pv10">
                  <Typography className="font-bold fs16 blue-color">
                    Variant Name: {slctedVariant?.variantName}
                  </Typography>
                  <Typography className="light-blue fs14 txt-semi-bold">
                    Variant Id: {slctedVariant?.variantNumber}
                  </Typography>
                  <Typography className="red-color fs14 txt-semi-bold">
                    Service Charge : Rs.{" "}
                    {Number(slctedVariant?.serviceCharge ?? 0)?.toFixed(2)}
                  </Typography>
                </div>
              </div>
            </div>
            <div className="green-back4 ph20 pv10 br10 mt20">
              <div className="flex-row-between-align-center">
                <Typography className="txt-semi-bold fs14 orange5">
                  Estimated Cost:
                </Typography>
                <Typography className="font-bold fs14 orange5 ml10">
                  Rs{" "}
                  {Number(
                    getTotalEstimatedCost([
                      ...(variantValues?.consumList ?? []),
                      ...(variantValues?.presList ?? []),
                    ])
                  )?.toFixed(2)}
                </Typography>
              </div>
            </div>
            <div className="mt20">
              <Card sx={cardSty}>
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Consumables
                  </Typography>
                </div>
                <div className="flex-column mt10">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Quantity <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Estimated Cost
                      </Typography>
                    </div>
                    <div className="w5Per" />
                    <div className="w10Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {variantValues?.consumList
                    ?.filter((li) => !li?.delete)
                    ?.map((li, i) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={i + "consum"}
                        >
                          <div className="w30Per pr10">
                            <CustomSelect
                              list={getList(false)}
                              value={li?.name}
                              addNewSelect
                              mandatoryField
                              error={!!li?.nameErr}
                              helperText={li?.nameErr}
                              handleChange={(e) => {
                                handleConsumChange("name", e?.value ?? e, i, {
                                  stockId: e?.stockId ?? null,
                                  batchId: e?.batchId ?? null,
                                  serviceId: e?.serviceId ?? null,
                                  category: e?.category ?? null,
                                });
                              }}
                              plusBtn
                            />
                          </div>
                          <div className="w25Per pr10">
                            <CustomTextField
                              value={li?.quantity}
                              error={!!li?.qtyErr}
                              helperText={li?.qtyErr}
                              handleChange={(e) =>
                                handleConsumChange(
                                  "quantity",
                                  e?.target?.value,
                                  i
                                )
                              }
                              fullWidth
                              type="number"
                            />
                          </div>
                          <div className="w30Per pr10 mt10">
                            <Typography className="txt-regular fs12 gray20 ml5">
                              {Number(li?.cost) > 0
                                ? `Rs ${Number(li?.cost)?.toFixed(2)}`
                                : "-"}
                            </Typography>
                          </div>
                          <div className="w5Per">
                            <div
                              className="cursor"
                              onClick={() =>
                                handleConsumAlternates(li?.i, true)
                              }
                            >
                              <div className="flex-center">
                                <AddIcon sx={plusBtn} />
                              </div>
                              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                Alternates
                              </Typography>
                            </div>
                          </div>
                          <div className="w10Per flex-end">
                            <div
                              className="cursor pr10"
                              onClick={() =>
                                handleConsumDelete(i, li?.detailId ?? null)
                              }
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleAddTask("consum")}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={plusBtn} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                </div>
              </Card>
            </div>
            <div className="mt20">
              <Card sx={cardSty}>
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Administered
                  </Typography>
                </div>

                <div className="flex-column mt10">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Dosage <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Route <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w20Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Estimated Cost
                      </Typography>
                    </div>
                    <div className="w5Per" />
                    <div className="w5Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {variantValues?.presList
                    ?.filter((li) => !li?.delete)
                    ?.map((pr, ind) => {
                      // const reqPack = getBatchList(
                      //   pr?.stockId
                      // )?.[0]?.packageUom?.match(/^(\d+)(.+)/);
                      const reqUnit =
                        getBatchList(pr?.stockId)?.[0]?.packageUom ?? "";
                      // reqPack
                      //   ? getBatchList(pr?.stockId)?.[0]?.dosage?.length > 0
                      //     ? `${getBatchList(pr?.stockId)?.[0]?.dosage}${
                      //         reqPack?.[2] ?? ""
                      //       }` ?? getBatchList(pr?.stockId)?.[0]?.packageUom
                      //     : getBatchList(pr?.stockId)?.[0]?.packageUom
                      //   : "";

                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={ind + "pres"}
                        >
                          <div className="w30Per pr10">
                            <Select
                              list={getList(true)}
                              value={pr?.name}
                              error={!!pr?.nameErr}
                              helperText={pr?.nameErr}
                              addNewSelect
                              mandatoryField
                              handleChange={(e) => {
                                handleChangeAdminsterValue(
                                  "name",
                                  e?.value ?? e,
                                  ind,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  }
                                );
                              }}
                              plusBtn
                            />
                          </div>
                          <div className="w25Per pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangeAdminsterValue(
                                  "dosage",
                                  e?.target?.value,
                                  ind
                                )
                              }
                              value={pr?.dosage}
                              error={!!pr?.dosErr}
                              helperText={pr?.dosErr}
                              suffix={
                                reqUnit?.length > 0 ? (
                                  <Custom3dotString
                                    str={`/${reqUnit}`}
                                    length={9}
                                    className="fs12 font-medium"
                                  />
                                ) : (
                                  ""
                                )
                              }
                              type="number"
                            />
                          </div>
                          <div className="w15Per pr10">
                            <Select
                              list={routeList}
                              value={pr?.route}
                              error={!!pr?.routeErr}
                              helperText={pr?.routeErr}
                              search
                              handleChange={(e, value) => {
                                handleChangeAdminsterValue("route", value, ind);
                              }}
                            />
                          </div>
                          <div className="w20Per pr10 mt10">
                            <Typography className="txt-regular fs12 gray20 ml5">
                              {Number(pr?.cost) > 0
                                ? `Rs ${Number(pr?.cost)?.toFixed(2)}`
                                : "-"}
                            </Typography>
                          </div>
                          <div className="w5Per">
                            <div
                              className="cursor"
                              onClick={() => handleAdminAlternates(pr?.i, true)}
                            >
                              <div className="flex-center">
                                <AddIcon sx={plusBtn} />
                              </div>
                              <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                                Alternates
                              </Typography>
                            </div>
                          </div>
                          <div className="w5Per">
                            <div
                              className="cursor ml10"
                              onClick={() =>
                                deleteAdministerByIndex(
                                  ind,
                                  pr?.prescriptionId ?? null
                                )
                              }
                            >
                              <div className="flex-center">
                                <DeleteOutlineIcon sx={delBtn} />
                              </div>
                              <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                Delete
                              </Typography>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  <div
                    className="flex-row-ali-cen mt10 cursor"
                    onClick={() => handleAddTask("pres")}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                </div>
              </Card>
            </div>
            <div className="mt20">
              <Card sx={cardSty}>
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Prescription
                  </Typography>
                </div>
                <div
                  style={{ overflowX: "auto", width: "100%" }}
                  className="mt10"
                >
                  <div style={{ minWidth: 1270 }}>
                    <div className="flex-row-ali-cen mh10">
                      <div style={{ width: 250 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Name <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Qty <span className="red-color">*</span>
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Dosage
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Duration
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Frequency
                        </Typography>
                      </div>
                      <div style={{ width: 150 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Instructions
                        </Typography>
                      </div>
                      <div style={{ width: 200 }}>
                        <Typography className="txt-semi-bold fs12 blue-color">
                          Remarks
                        </Typography>
                      </div>
                      <div style={{ width: 70 }} />
                    </div>
                    <div className="blue-hor-split mt5" />
                    {variantValues?.prescriptions
                      ?.filter((li) => !li?.delete)
                      ?.map((pr, ind) => {
                        const reqUnit = getBatchList(pr?.stockId)?.[0]
                          ?.packageUom;
                        return (
                          <div
                            className="flex-row mt10 plan-bor"
                            key={ind + "pres"}
                          >
                            <div className="pr10" style={{ width: 250 }}>
                              <Select
                                list={getPresList()}
                                value={pr?.name}
                                error={!!pr?.nameErr}
                                helperText={pr?.nameErr}
                                addNewSelect
                                mandatoryField
                                handleChange={(e) => {
                                  handleChangePrescripValue(
                                    "name",
                                    e?.value ?? e,
                                    ind,
                                    {
                                      stockId: e?.stockId ?? null,
                                      productId: e?.productId ?? null,
                                      serviceId: e?.serviceId ?? null,
                                      type: e?.type,
                                    }
                                  );
                                }}
                                plusBtn
                              />
                            </div>
                            <div className="pr10" style={{ width: 150 }}>
                              <CustomTextField
                                value={pr?.qty}
                                error={!!pr?.qtyErr}
                                helperText={pr?.qtyErr}
                                handleChange={(e) => {
                                  handleChangePrescripValue(
                                    "qty",
                                    e?.target?.value,
                                    pr?.i
                                  );
                                }}
                                fullWidth
                                type="number"
                                endIcon
                                inputIcon={
                                  <Custom3dotString
                                    str={`${
                                      getBatchList(pr?.stockId)?.[0]
                                        ?.salesUom ?? ""
                                    }`}
                                    length={7}
                                    className="fs12 font-medium"
                                  />
                                }
                              />
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangePrescripValue(
                                    "dosage",
                                    e?.target?.value,
                                    ind
                                  )
                                }
                                value={pr?.dosage}
                                error={!!pr?.dosErr}
                                helperText={pr?.dosErr}
                                suffix={
                                  reqUnit?.length > 0 ? (
                                    <Custom3dotString
                                      str={`/${reqUnit}`}
                                      length={7}
                                      className="fs12 font-medium"
                                    />
                                  ) : (
                                    ""
                                  )
                                }
                                type="number"
                              />
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangePrescripValue(
                                    "duration",
                                    e?.target?.value,
                                    pr?.i
                                  )
                                }
                                value={pr?.duration}
                                endIcon
                                inputIcon="days"
                                type="number"
                              />
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              {pr?.customFrequency ? (
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    handleChangePrescripValue(
                                      "frequency",
                                      e?.target?.value,
                                      pr?.i
                                    )
                                  }
                                  value={pr?.frequency}
                                />
                              ) : (
                                <CustomSelect
                                  list={frequncyCheckList}
                                  value={pr?.frequency ?? []}
                                  handleChange={(e) => {
                                    handleChangePrescripValue(
                                      "frequency",
                                      e?.target?.value,
                                      pr?.i
                                    );
                                  }}
                                  multiSelectTagCheck
                                />
                              )}
                            </div>
                            <div style={{ width: 150 }} className="pr10">
                              <CustomSelect
                                list={mealTypes}
                                value={pr?.meal}
                                select
                                handleChange={(e) => {
                                  handleChangePrescripValue(
                                    "meal",
                                    e?.target?.value,
                                    pr?.i
                                  );
                                }}
                              />
                            </div>
                            <div style={{ width: 200 }} className="pr10">
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangePrescripValue(
                                    "remark",
                                    e?.target?.value,
                                    pr?.i
                                  )
                                }
                                value={pr?.remark}
                              />
                            </div>
                            <div style={{ width: 70 }}>
                              <div
                                className="cursor ml10"
                                onClick={() =>
                                  deletePricripByIndex(
                                    ind,
                                    pr?.prescriptionId ?? null
                                  )
                                }
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                            </div>
                          </div>
                        );
                      })}

                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => handleAddTask("prescriptions")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={addIcon} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div className="flex1-end mt20">
              <div>
                <CustomButton text="Save" smallBtn onClick={saveVariant} />
              </div>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          open={getOpenedConsum()}
          onClose={onCloseConsumMod}
          header="Consumables"
          modal
          modalWidth={90}
        >
          <div className="scroll-80vh">
            <div className="flex-row-ali-cen">
              <div className="flex-row-ali-cen">
                <Typography className="font-bold fs14 blue-color">
                  Consumables
                </Typography>
              </div>
            </div>

            <div className="flex-column mt10">
              <div className="flex-row-ali-cen mh10">
                <div className="w15Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Default Item
                  </Typography>
                </div>
                <div className="w30Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Name <span className="red-color">*</span>
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Quantity <span className="red-color">*</span>
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Estimated Cost
                  </Typography>
                </div>
                <div className="w5Per" />
              </div>
              <div className="blue-hor-split mt5" />
              {alternates
                ?.filter((li) => !li?.delete)
                ?.map((li, i) => {
                  return (
                    <div
                      className="flex-row mt10 plan-bor"
                      key={li?.i + "consum var"}
                    >
                      <div className="w15Per">
                        <div className="ml10">
                          <CustomCheckbox
                            checked={li?.isDefault}
                            onChange={() => onChangeConsumDefault(li?.i)}
                          />
                        </div>
                      </div>
                      <div className="w30Per pr10">
                        <CustomSelect
                          list={getModalList(false)}
                          value={li?.name}
                          addNewSelect
                          mandatoryField
                          error={!!li?.nameErr}
                          helperText={li?.nameErr}
                          handleChange={(e) => {
                            onChangeConsumValue("name", e?.value ?? e, li?.i, {
                              stockId: e?.stockId ?? null,
                              batchId: e?.batchId ?? null,
                              serviceId: e?.serviceId ?? null,
                              category: e?.category ?? null,
                            });
                          }}
                          plusBtn
                        />
                      </div>
                      <div className="w25Per pr10">
                        <CustomTextField
                          value={li?.quantity}
                          error={!!li?.qtyErr}
                          helperText={li?.qtyErr}
                          handleChange={(e) =>
                            onChangeConsumValue(
                              "quantity",
                              e?.target?.value,
                              li?.i
                            )
                          }
                          fullWidth
                          type="number"
                        />
                      </div>
                      <div className="w25Per pr10 mt10">
                        <Typography className="txt-regular fs12 gray20 ml5">
                          {Number(li?.cost) > 0
                            ? `Rs ${Number(li?.cost)?.toFixed(2)}`
                            : "-"}
                        </Typography>
                      </div>
                      <div className="w5Per flex-end mt5">
                        {!li?.isDefault ? (
                          <div
                            className="cursor pr10"
                            onClick={() =>
                              onDeleteAlterConsum(li?.i, li?.detailId ?? null)
                            }
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              <div
                className="flex-row-ali-cen mt10 cursor"
                onClick={handleAddConsum}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={plusBtn} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
              <div className="flex1-end">
                <div>
                  <CustomButton
                    text="Save"
                    smallBtn
                    onClick={handleSaveConsum}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          open={getOpenedAdmin()}
          onClose={onCloseAdminMod}
          header="Administered"
          modal
          modalWidth={90}
        >
          <div className="scroll-80vh">
            <div className="flex-row-ali-cen" onClick={handleAdminOpen}>
              <Typography className="font-bold fs14 blue-color">
                Administered
              </Typography>
            </div>
            <div className="flex-column mt10">
              <div className="flex-row-ali-cen mh10">
                <div className="w15Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Default Item
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Name <span className="red-color">*</span>
                  </Typography>
                </div>
                <div className="w25Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Dosage <span className="red-color">*</span>
                  </Typography>
                </div>
                <div className="w15Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Route <span className="red-color">*</span>
                  </Typography>
                </div>
                <div className="w15Per">
                  <Typography className="txt-semi-bold fs12 blue-color">
                    Estimated Cost
                  </Typography>
                </div>
                <div className="w5Per" />
              </div>
              <div className="blue-hor-split mt5" />
              {alternates
                ?.filter((li) => !li?.delete)
                ?.map((pr, ind) => {
                  return (
                    <div
                      className="flex-row mt10 plan-bor"
                      key={ind + "admin var"}
                    >
                      <div className="w15Per">
                        <div className="ml10">
                          <CustomCheckbox
                            checked={pr?.isDefault}
                            onChange={() => onChangeAdminDefault(pr?.i)}
                          />
                        </div>
                      </div>
                      <div className="w25Per pr10">
                        <Select
                          list={getModalList(true)}
                          value={pr?.name}
                          error={!!pr?.nameErr}
                          helperText={pr?.nameErr}
                          addNewSelect
                          mandatoryField
                          handleChange={(e) => {
                            onChangeAdminValue("name", e?.value ?? e, pr?.i, {
                              stockId: e?.stockId ?? null,
                              productId: e?.productId ?? null,
                              serviceId: e?.serviceId ?? null,
                              type: e?.type,
                            });
                          }}
                          plusBtn
                        />
                      </div>
                      <div className="w25Per pr10">
                        <CustomTextField
                          fullWidth
                          handleChange={(e) =>
                            onChangeAdminValue(
                              "dosage",
                              e?.target?.value,
                              pr?.i
                            )
                          }
                          value={pr?.dosage}
                          error={!!pr?.dosErr}
                          helperText={pr?.dosErr}
                          suffix={
                            getBatchList(pr?.stockId)?.[0]?.packageUom ? (
                              <Custom3dotString
                                str={`/${
                                  getBatchList(pr?.stockId)?.[0]?.packageUom
                                }`}
                                length={9}
                                className="fs12 font-medium"
                              />
                            ) : (
                              ""
                            )
                          }
                          type="number"
                        />
                      </div>
                      <div className="w15Per pr10">
                        <Select
                          list={routeList}
                          value={pr?.route}
                          error={!!pr?.routeErr}
                          helperText={pr?.routeErr}
                          search
                          handleChange={(e, value) => {
                            onChangeAdminValue("route", value, pr?.i);
                          }}
                        />
                      </div>
                      <div className="w15Per pr10 mt10">
                        <Typography className="txt-regular fs12 gray20 ml5">
                          {Number(pr?.cost) > 0
                            ? `Rs ${Number(pr?.cost)?.toFixed(2)}`
                            : "-"}
                        </Typography>
                      </div>
                      <div className="w5Per mt5">
                        {!pr?.isDefault ? (
                          <div
                            className="cursor ml10"
                            onClick={() =>
                              onDeleteAlterAdmin(
                                pr?.i,
                                pr?.prescriptionId ?? null
                              )
                            }
                          >
                            <div className="flex-center">
                              <DeleteOutlineIcon sx={delBtn} />
                            </div>
                            <Typography className="red3 fs8 txt-semi-bold text-align-center">
                              Delete
                            </Typography>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}

              <div
                className="flex-row-ali-cen mt10 cursor"
                onClick={handleAddAdmin}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
              <div className="flex1-end">
                <div>
                  <CustomButton
                    text="Save"
                    smallBtn
                    onClick={handleSaveAdmin}
                  />
                </div>
              </div>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          open={filterValues?.visible}
          onClose={onCloseFilter}
          header="Filter"
          rightModal
          modalWidth={30}
        >
          <div className="scroll-80vh ph20">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className="gray38 fs12 txt-regular">
                  Filter by:
                </Typography>
                {!filterValues?.added ? (
                  filterByList?.map((li, i) => (
                    <div className="flex-row-ali-cen" key={`${i}_li`}>
                      <div>
                        <CustomCheckbox
                          checked={filterValues?.selectedList?.includes(li)}
                          onChange={() => onSelectFilter(li)}
                        />
                      </div>
                      <Typography className="txt-regular fs14 black mb5 mlMin15">
                        {li}
                      </Typography>
                    </div>
                  ))
                ) : (
                  <div>
                    <div
                      className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                      onClick={() => onFilterAdd(false)}
                    >
                      <AddIcon
                        sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                      />
                      <Typography className="font-medium fs12 blue-color ml5">
                        Add Filter
                      </Typography>
                    </div>
                    <div>
                      {filterValues?.selectedList?.map((li) => (
                        <div className="mt20">
                          {li === "Price Range" ? (
                            <div className="flex-row-between-align-center">
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder="Min Price"
                                  fullWidth
                                  name="Min Price"
                                  label="Min Price"
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.["Min Price"] ?? ""
                                  }
                                  type="number"
                                />
                              </div>
                              <div className="w45Per">
                                <CustomTextField
                                  placeholder="Max Price"
                                  fullWidth
                                  name="Max Price"
                                  label="Max Price"
                                  handleChange={onFilterValuesChange}
                                  value={
                                    filterValues?.values?.["Max Price"] ?? ""
                                  }
                                  type="number"
                                />
                              </div>
                            </div>
                          ) : (
                            <CustomTextField
                              placeholder={li}
                              fullWidth
                              name={li}
                              handleChange={onFilterValuesChange}
                              value={filterValues?.values?.[li] ?? ""}
                              label={li}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {!filterValues?.added ? (
                  <div className="flex1-end mt15">
                    <div>
                      <CustomButton
                        text="Add"
                        smallBtn
                        onClick={() => onFilterAdd(true)}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex-row-center mt15">
                    <div>
                      <CustomButton
                        text="Reset All"
                        smallBtn
                        onClick={onFilterReset}
                        tabSelectdBtn
                      />
                    </div>
                    <div className="ml20">
                      <CustomButton
                        text="Apply Filters"
                        smallBtn
                        onClick={onApplyFilter}
                      />
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </CustomModal>
      </div>
    </Container>
  );
};

export default Service;
